import React from 'react';

import './oddStatistic.scss';

interface Props {
    show?: boolean;
    percent?: number | null;
}

const OddStatistic: React.FC<Props> = props => {
    const { show, percent } = props;

    if (!show) return null;

    return percent ? (
        <div styleName="percent exist" className="__app-OddStatistic-percent">
            {percent}%
        </div>
    ) : (
        <div
            styleName="percent not-exist"
            className="__app-OddStatistic-not-exist"
        />
    );
};

export default React.memo(OddStatistic);
